import { render, staticRenderFns } from "./AboutKgl.vue?vue&type=template&id=2cdbad98&scoped=true"
import script from "./AboutKgl.vue?vue&type=script&lang=js"
export * from "./AboutKgl.vue?vue&type=script&lang=js"
import style0 from "./AboutKgl.vue?vue&type=style&index=0&id=2cdbad98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdbad98",
  null
  
)

export default component.exports